import React, { useEffect } from "react";
import Spinner from "../common/Spinner/Spinner";
import { startSignIn } from "../auth/OIDCAuthHandler";

// Used by the in-page login modals: starts the PKCE redirect and returns to the current page after sign-in.
const LoginForm = () => {
  useEffect(() => {
    const { pathname, search, hash } = window.location;
    startSignIn(`${pathname}${search}${hash}`);
  }, []);

  return (
    <div className="mt-10 mb-10 flex justify-center" role="status" aria-live="polite" aria-busy="true">
      <span className="sr-only">Redirecting to sign in…</span>
      <Spinner />
    </div>
  );
};

export default LoginForm;
